import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { catchError, Observable, retry } from "rxjs";
import { BaseService } from "../../services/base.service";
import { OrderHistoryEvent } from "../models-otc/order-history-event.model";
import { MatSnackBar } from "@angular/material/snack-bar";

@Injectable({
    providedIn: "root",
})
export class OrderHistoryService extends BaseService {
    constructor(
        private httpClient: HttpClient,
        public snackBar: MatSnackBar
    ) {
        super();
    }

    getOrderHistory(orderId: number): Observable<OrderHistoryEvent[]> {
        return this.httpClient
            .get<OrderHistoryEvent[]>(this.OTC_BASE_URL + `orders/${orderId}/history`)
            .pipe(
                retry(0),
                catchError((err) => {
                    this.hasError.next(true);
                    this.snackBar.open("Error loading order history", "close", {
                        duration: 5000,
                    });
                    this.hasError.next(false);
                    return this.errorHandler(err);
                })
            );
    }
}
